import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import useSignup from '../hooks/useSignup';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import '../style/Signup.css';

const Signup = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { signup, error, isLoading } = useSignup();
    const [success, setSuccess] = useState('');
    const { t } = useTranslation();

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await signup(name, email, password, i18n.language);
            setSuccess(t('signup.success'));
            setName('');
            setEmail('');
            setPassword('');
        } catch (err) {
            console.error('Error during signup:', error);
        }
    };



    return (
        <div className="signup-container bg-dafauna-background rounded-xl shadow-md p-8">
            <form onSubmit={handleSubmit} className="space-y-4">
                {/* ...existing code... */}
                <h2 className="text-dafauna-darkText text-2xl font-bold text-center">{t('signup.title')}</h2>
                <div>
                    <label className="block text-dafauna-darkText font-medium">{t('signup.name')}</label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                        className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-dafauna-primary"
                    />
                </div>
                <div>
                    <label className="block text-dafauna-darkText font-medium">{t('signup.email')}</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-dafauna-primary"
                    />
                </div>
                <div>
                    <label className="block text-dafauna-darkText font-medium">{t('signup.password')}</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-dafauna-primary"
                    />
                </div>
                <button
                    type="submit"
                    disabled={isLoading}
                    className="w-full bg-dafauna-primary text-white rounded-md px-4 py-2 hover:bg-dafauna-primaryLight disabled:bg-gray-300 disabled:cursor-not-allowed"
                >
                    {isLoading ? t('signup.loading') : t('signup.submit')}
                </button>
                {success && <div className="success text-green-500 text-sm text-center mt-2">{success}</div>}
                {error && <div className="error text-red-500 text-sm text-center mt-2">{t('signup.error')}: {error}</div>}
            </form>
            <div className="login-redirect text-center text-dafauna-darkText mt-4">
                <p>
                    {t('signup.alreadyRegistered')}{' '}
                    <Link to="/login" className="text-dafauna-primary hover:underline">{t('signup.loginHere')}</Link>
                </p>
            </div>
        </div>
    );
};

export default Signup;